<template>
  <div class="k8m-cluster-metrics-wrapper">
    <div class="k8m-cluster-metrics-Container">
      <div
        v-for="data in clusterMetricsData"
        :key="data.key"
        class="k8m-cluster-stats-container"
      >
        <InfoStats
          :className="data.className"
          :textTitle="data.textTitle"
          :textValColor="data.textValColor"
          :textValue="data.textValue"
        />
      </div>
    </div>
  </div>
</template>

<script>
import InfoStats from '@/rex-components/rex-info-stats.vue';
import { k8Scopes } from '@/store/modules/k8/k8-types';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: { InfoStats },
  name: 'ClusterMetricCards',
  props: {
    clusterMetricsData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      scope: k8Scopes.SERVICE_INSTANCE,
      metricResponse: [],
    };
  },
  computed: {
    ...mapGetters('k8State/k8CommonState', ['getCurrentK8Cluster']),
    ...mapGetters('globalState/settings', ['getDurationTime']),
  },
  methods: {
    ...mapActions('k8State/k8CommonState', {
      getK8CardsDataAction: 'GET_K8_CARDS_PROPERTIES',
      getServiceInstanceCount: 'GET_K8_SERVICE_INSTANCE_COUNT',
    }),
    getMetricbyNameOfCards(type) {
      return this.clusterMetricsData
        .filter((item) => item.valueType === type)
        .map((item) => item.metricName);
    },
    async fetchValueCardsProperties(type) {
      if (type === 'instance') {
        try {
          this.metricResponse = [];
          let metricNames = this.getMetricbyNameOfCards(type);
          const params = {
            serviceId: this.getCurrentK8Cluster.key,
            duration: this.getDurationTime,
            instanceTypes: metricNames,
          };
          const metricData = await this.getServiceInstanceCount(params);
          if (
            Array.isArray(metricData.metricsValue) &&
            metricData.metricsValue.length > 0
          ) {
            this.metricResponse = metricData.metricsValue;
            this.populateInfoCardData();
          }
        } catch (error) {
          console.log(error);
          this.metricResponse = [];
        }
      } else {
        try {
          this.metricResponse = [];
          let metricNames = this.getMetricbyNameOfCards(type);
          const params = {
            request: {
              metricNames: metricNames,
              entity: {
                scope: this.scope,
                serviceName: this.getCurrentK8Cluster?.key,
                serviceInstanceName: this.getCurrentK8Cluster?.key,
                normal: true,
              },
            },
            duration: this.getDurationTime,
            valueColumn: type,
          };
          const metricData = await this.getK8CardsDataAction(params);
          if (Array.isArray(metricData) && metricData.length > 0) {
            this.metricResponse = metricData;
            this.populateInfoCardData();
          }
        } catch (error) {
          console.log(error);
          this.metricResponse = [];
        }
      }
    },
    populateInfoCardData() {
      this.clusterMetricsData.map((item) => {
        let value =
          this.metricResponse
            .find((resp) => resp.name === item.metricName)
            ?.value?.toString() ?? item?.textValue;
        item.textValue = value;
      });
    },
  },
  mounted() {
    this.fetchValueCardsProperties('instance');
    this.fetchValueCardsProperties('value');
  },
  watch: {
    getDurationTime() {
      this.fetchValueCardsProperties('value');
      this.fetchValueCardsProperties('instance');
    },
    'getCurrentK8Cluster.key'() {
      this.fetchValueCardsProperties('value');
      this.fetchValueCardsProperties('instance');
    },
  },
};
</script>

<style lang="scss" scoped>
.k8m-cluster-metrics-Container {
  margin: -0.4rem;
  display: grid;
  width: 100%;
  grid-template-columns: 14.28% 14.28% 14.28% 14.28% 14.28% 14.28% 14.28%;
}
.k8m-cluster-stats-container {
  display: flex;
}
.k8m-cluster-info-cards {
  margin: 0.397rem;
  border-radius: 0.75rem;
  padding-left: 2.188rem;
  padding-bottom: 2rem;
  padding-top: 1.5rem;
}
.k8m-cluster-metrics-wrapper {
  @include flex-row-wrap;
  margin-top: 1.23rem;
  align-items: center;
}
</style>
